/**
 * Created by lakshan on 6/6/17.
 */
(function() {
	'use strict';

	/**
	 * @ngdoc service
	 * @name messageAdmin.service:MessageAdminService
	 *
	 * @description
	 *
	 */
	angular.module('messageInbox').service('MessageInboxService', MessageInboxService);

	function MessageInboxService(RemoteService, MessageInboxFactory, EventManagerService) {

		var self = this;
		var model = {
			allCrewList : null
		};
		
		self.adaptCrewList = function (crewList) {
            angular.forEach(crewList, function (crew) {
                crew.displayName = crew.firstName + ' ' + crew.lastName + ' (' +crew.crewId + ')';
            });
            return crewList;
        };
        
        self.getAllCrewList = function(successFn, errorFn) {
        	if(model.allCrewList == null){
        		RemoteService.getAllCrewDisplayNameList().then(
    				function(response) {
    					if (response.success && !!response.crewDetail) {
    						model.allCrewList = response.crewDetail;
    						successFn(MessageInboxFactory.setSelectedFlag(response.crewDetail));
    					}
    				}, function(error) {
    					errorFn(error.msg[0]);
    				});
        	} else {
        		successFn(model.allCrewList);
        	}
        };
        
        
        self.replyMessage = function(request, successFn, errorFn) {
    		RemoteService.replyMessage(request).then(
				function (response) {
					successFn(response);
				},
				function (error) {
					errorFn(error);
			});
        };
        

		self.searchMessageInbox = function(searchParam, successFn, errorFn) {
			var requestParam = MessageInboxFactory.searchMessageInboxRQ(searchParam);
			RemoteService.searchMessageInbox.call(this, requestParam).then(
				function (response) {
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
			);
		}
		
		self.markAsRead = function(requestParam, successFn, errorFn) {
			var processedRequestParam = MessageInboxFactory.markAsReadRQ(requestParam);
			RemoteService.markAsRead.call(this, processedRequestParam).then(
				function (response) {
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
			);
		}
		
		self.deleteMessage = function(messageId, successFn, errorFn) {
			var messageRequest = MessageInboxFactory.deleteMessageRQ(messageId);
			RemoteService.deleteMessage.call(this, messageRequest).then(
				function (response) {
					successFn(response);
				},
				function (error) {
					errorFn(error);
				}
			);
		}

		self.appendToGridMessageList = function (existingGridMessageData, newGridMessageData) {
			angular.forEach(newGridMessageData.list, function (messageObj) {
				var foundMessageIndex = _.findIndex(existingGridMessageData.list, {messageUserId: messageObj.messageUserId})
				if (foundMessageIndex >= 0) {
					existingGridMessageData.list.splice(foundMessageIndex, 1, messageObj);
				} else {
					existingGridMessageData.list.push(messageObj);
				}
			});
		};

	}
})();
